export default "__VITE_ASSET__BSqPjDD1__"